module.exports = [["INCLUDE","mask_passwords"]]